import { useQuery } from '@apollo/client';
import { Box, Stack } from 'braid-design-system';
import React, { useState } from 'react';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import { Error } from 'src/components/Error/Error';
import {
  type SavedListing,
  GetSavedListingsDocument,
} from 'src/generated/graphql';

import NoResultsPanel from './components/NoResultsPanel';
import SavedBusiness from './components/SavedItem';
import SortDropdown from './components/SortDropdown';

type Sort = 'Date saved' | 'Date posted';

const SavedBusinesses = () => {
  const { data, loading, error } = useQuery(GetSavedListingsDocument);
  const [sortBy, setSortMethod] = useState<Sort>('Date saved');

  if (loading) {
    return <CustomLoader />;
  }

  if (error || !data) {
    return <Error />;
  }

  if (data.savedListings.length === 0) {
    return <NoResultsPanel />;
  }

  const sortedListings = sortListings(data.savedListings, sortBy);

  return (
    <Stack space="medium">
      {sortedListings.length > 1 && (
        <Box paddingRight="medium" paddingBottom="medium">
          <SortDropdown value={sortBy} onChange={setSortMethod} />
        </Box>
      )}

      {sortedListings.map((listing) => (
        <SavedBusiness key={listing.listingId} listing={listing} />
      ))}
    </Stack>
  );
};
export default SavedBusinesses;

// ============================================================================
// Helpers
// ============================================================================
const sortListings = (listings: SavedListing[], sortBy: string) => {
  if (sortBy === 'Date posted') {
    return [...listings].sort(function (x: SavedListing, y: SavedListing) {
      const xDate = new Date(x.createdDate ?? new Date());
      const yDate = new Date(y.createdDate ?? new Date());
      return xDate.getTime() > yDate.getTime() ? -1 : 1;
    });
  }

  return [...listings].sort(function (x: SavedListing, y: SavedListing) {
    const xDate = new Date(x.savedDate ?? new Date());
    const yDate = new Date(y.savedDate ?? new Date());
    return xDate.getTime() > yDate.getTime() ? -1 : 1;
  });
};
